export const AUTO_HEIGHT_SKELETON_ROW_COUNT = 10;

export const getSkeletonRowCount = (bodyHeight: number, rowHeight: number): number =>
  rowHeight > 0 ? Math.max(0, Math.floor(bodyHeight / rowHeight)) : 0;

export const buildSkeletonRows = (rowCount: number, columnCount: number): null[][] =>
  Array.from({ length: rowCount }, () => Array.from({ length: columnCount }, () => null));
